import React, { useRef } from 'react';

import { useToggle } from '../../hooks';
import {
    IMaterialDataTableEditRow, IMaterialDataTableRow, TValidContentTypes
} from '../../prop-types';
import { reduceCells } from '../../shared';
import Visible from '../Visible';
import CreateRow from './CreateRow';
import DeleteRow from './DeleteRow';
import EditRow from './EditRow';
import StandardRow from './StandardRow';

interface IMaterialDataTableRowProps<C extends TValidContentTypes[]>
  extends IMaterialDataTableRow<C> {
  addMode?: boolean;
  onSave: (rowData: IMaterialDataTableEditRow<TValidContentTypes>) => void;
  onDelete?: (rowData: IMaterialDataTableEditRow<TValidContentTypes>) => void;
  onCancel?: () => void;
  readOnly: boolean;
}

export default function Row<C extends TValidContentTypes[]>({
  id,
  cells,
  props,
  addMode: isAddMode = false,
  onSave,
  onDelete = () => null,
  onCancel = () => null,
  readOnly
}: IMaterialDataTableRowProps<C>) {
  const [isEditMode, toggleIsEditMode] = useToggle();
  const [isDeleteMode, toggleIsDeleteMode] = useToggle();
  const rowData = { current: reduceCells(cells)};
  const handleValueChange = <T extends TValidContentTypes>(
    content: T,
    index: number
  ) => {
    const nextRowData = rowData.current;
    nextRowData[index] = { ...nextRowData[index], content };
    rowData.current = nextRowData;
  };

  const handleConfirm = () => {
    onSave({ id: id, cells: rowData.current, props });
    resetMode();
  };

  const handleDeleteConfirm = () => {
    onDelete({ id: id, cells: rowData.current, props });
    resetMode();
  };

  const resetMode = () => {
    if (isEditMode) {
      toggleIsEditMode();
    }
    if (isDeleteMode) {
      toggleIsDeleteMode();
    }
  };

  if (isAddMode) {
    console.log(cells)
    return (
      <CreateRow
        cells={cells}
        onValueChange={handleValueChange}
        onConfirm={handleConfirm}
        onCancel={onCancel}
      />
    );
  }

  return (
    <>
      <Visible if={isEditMode}>
        <EditRow
          {...props}
          cells={cells}
          onValueChange={handleValueChange}
          onConfirm={handleConfirm}
          onCancel={resetMode}
        />
      </Visible>
      <Visible if={isDeleteMode}>
        <DeleteRow
          {...props}
          cells={cells}
          onConfirm={handleDeleteConfirm}
          onCancel={resetMode}
        />
      </Visible>
      <Visible if={!isEditMode && !isDeleteMode}>
        <StandardRow
          {...props}
          cells={cells}
          onEditClick={toggleIsEditMode}
          onDeleteClick={toggleIsDeleteMode}
          readOnly={readOnly}
        />
      </Visible>
    </>
  );
}
